// extracted by mini-css-extract-plugin
export default {"addressBlock":"addressBlock___CY3Dk"};